import * as ko from "knockout";
import {TBaseOrObservableOrFunctionType} from "../../../index";

export namespace nsUtils {

    export function isNullOrUndefined(val: any): boolean {
        return val === null || val === undefined
    }

    export function isNullOrUndefinedOrEmptyString(val: any): boolean {
        return isNullOrUndefined(val) || val === ''
    }

    export function validateEmail(email: string): boolean {
        const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regExp.test(email);
    }

    let counter = 0;

    export function getNextId(): number {
        return ++counter;
    }

    export function getAnyValue<T = any>(obj: TBaseOrObservableOrFunctionType<T>): T {
        let ret: any = obj
        if (ko.isObservable(ret)) {
            ret = ko.unwrap(ret)
            // make a recursive call to see if we can "dig deeper"
            return getAnyValue(ret)
        }
        if (typeof ret === 'function') {
            return getAnyValue(ret())
        }
        return ret
    }

}